<template>
  <div class="column3-container">
    <Header></Header>
    <Center :price="linePrice"></Center>
    <Foot :price="linePrice"></Foot>
  </div>
</template>

<script>
import { getLine } from '../../api/colunm3';
import Header from './components/Header'
import Center from './components/Center'
import Foot from './components/Foot'
export default {
  components: {
    Header,
    Center,
    Foot
  },

  data () {
    return {
      linePrice: [
        {
          aturnover: 0
        },
        {
          aturnover: 0
        },
        {
          aturnover: 0
        },
        {
          aturnover: 0
        },
      ],
      timer: null
    }
  },

  created () {
    this.getLinePrice()
  },

  methods: {
    getLinePrice () {
      getLine().then(res => {
        this.linePrice = res
        this.timer && clearInterval(this.timer)
        this.timer = setTimeout(this.getLinePrice, 1000 * 5)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.column3-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 1404px;
  margin-right: 36px;
}
</style>